import { ErrorOutlineRounded, MailOutlineRounded } from '@mui/icons-material'
import { InformationCard } from 'feature/informationCard'
import { useConfirmUserEmailMutation } from 'feature/user/redux/user.api'
import { useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import { LoaderInCentalPosition } from 'widget'

// страница подтверждение почты
export function EmailConfirm() {
  const params = useParams()
  const requestSentRef = useRef(false)
  const [confirmUserEmail, { isLoading, isError }] =
    useConfirmUserEmailMutation()

  useEffect(() => {
    if (params.token && !requestSentRef.current) {
      confirmUserEmail(params.token)
      requestSentRef.current = true
    }
  }, [])

  if (isLoading) {
    return (
      <>
        <LoaderInCentalPosition />
      </>
    )
  }

  if (isError) {
    return (
      <>
        <InformationCard
          title='Ошибка'
          subtitle='Ссылка, по которой Вы перешли, некорректна или устарела.'
          Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
          link='/settings'
          linkText='В профиль'
        />
      </>
    )
  }

  return (
    <>
      <InformationCard
        title='Подтверждение электронной почты'
        subtitle='Адрес электронной почты успешно подтвержден'
        Icon={<MailOutlineRounded fontSize='large' color='primary' />}
        link='/settings'
        linkText='В профиль'
      />
    </>
  )
}
